import React from 'react'
import './StepProgressBar.css'

const StepProgressBarUI = ({values, selected}) =>
  <div className='w_step_progress g_flex_h' >
    {
      values.map((value, i) =>
        <React.Fragment key={i} >
          <span className='g_flex_v' style1={{borderWidth: 1, borderStyle: 'solid'}}>
            <div className={`dot ${selected === value ? 'selected' : ''}`} />
            <span>{value}</span>
          </span>
          {
            i < values.length -1 &&
            <span className='dash g_m_top_50'>&nbsp;</span>
          }
        </React.Fragment>
      )
    }
  </div>

export default StepProgressBarUI
